import { Spin } from "antd";
import React, { memo, useEffect } from "react";
import styled from "styled-components";
import { FullImageList } from "../../FullImageList";
import { SaleInfoCard, clampSaleCardScale, useResponsiveScale } from "../SaleInfoCard";

type SixProps = {
  item: any;
  num: number;
  fontScale?: number;
  isActive?: boolean;
};

const SixComponent: React.FC<SixProps> = ({ item, num, fontScale = 1, isActive = false }) => {
  const ref = React.useRef<HTMLDivElement>(null);

  const [loading, setLoading] = React.useState(true);
  const baseWidth = 620;
  const scale = useResponsiveScale(ref, baseWidth, { min: 0.6, max: 1.2 });
  const displayScale = clampSaleCardScale(scale * fontScale);

  useEffect(() => {
    if (item) {
        if( ref.current){
        setLoading(false);
        }
    }
  }, [item]);
  // useEffect(() => {
  //   console.log('item', item)
  // }, [item]);

  
  if (loading) {
      return (
        <SixTextContainer ref={ref}>
          <Spin size="large" />
        </SixTextContainer>
      );
  }

  return (
    <>
      {item[num]?.saleInfo?.saleType ?
        <SixTextContainer ref={ref}>
          <SaleInfoCard
            info={item[num]?.saleInfo}
            scale={displayScale}
            showDescription={false}
          />
        </SixTextContainer>
        :
        <SixTextContainer ref={ref}>
        <FullImageList
          key={`six-${num}-${isActive ? 'active' : 'idle'}`}
          imagelist={item[num]?.imageUrlList}
          isWidth={true}
          setItem={item}
          width={"620px"}
          type={'six'}
          num={num}
          globalScale={fontScale}
          isActive={isActive}
          deferUntilActive
        />
        </SixTextContainer>
      }
    </>
  );
};

export const Six = memo(
  SixComponent,
  (prev, next) =>
    prev.item === next.item &&
    prev.num === next.num &&
    prev.fontScale === next.fontScale &&
    prev.isActive === next.isActive
);

const SixTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-width: 0;
  min-height: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;
